import {nanoid} from "nanoid"

export const getMerkmal = (widget) =>
    widget?.connections ? widget.connections.origin : null

export const getError = (widget) =>
    widget?.connections ? widget.connections.origin : null

export const getOptions = (widget) =>
    getMerkmal(widget)?.connections?.origin?.children ?? []

export const getObjekteFromWidget = (widget) => widget?.objekte?.origin?.children ?? []

export const getAntworttyp = (widget) => getMerkmal(widget)?.antworttyp
export const getPointerOfWidget = (widget) => getMerkmal(widget)?.pointer

export const widgetFromDomaintypeGenerator = (
    domaintype,
    pointer,
    additionalEnums,
    action,
    showText = true
) => {
    const id = nanoid()
    return {
        id: id,
        type: "leafNode",
        placeholder: domaintype.description,
        text: showText && domaintype.question,
        x: 0,
        y: 1,
        w: 1,
        h: 1,
        component:
            additionalEnums && domaintype.antworttyp === "ENUMERATION_SINGLE"
                ? "ENUMERATION_SINGLE_ADDITIONAL"
                : domaintype.antworttyp,
        connections: {
            id: domaintype.id,
            treeName: "attributes",
            origin: {
                ...domaintype,
                pointer,
            },
        },
        i: id,
        moved: false,
        static: false,
        action
    }
}

/**
 * Recursively clones an object and replaces all instances of '[i]' with 'replaceString' in string values.
 * @param {object} obj - The object to process.
 * @param {string} replaceString - the string to replace with
 * @returns {object} - The modified, cloned object.
 */
export function cloneAndReplace(obj, replaceString) {
    const clonedObj = _.cloneDeep(obj)

    function traverseAndReplace(currentObj) {
        for (const key in currentObj) {
            const value = currentObj[key]

            if (typeof value === "string") {
                currentObj[key] = value.replace(/\[i\]/g, replaceString)
            } else if (_.isObject(value)) {
                traverseAndReplace(value)
            } else if (Array.isArray(value)) {
                value.forEach(item => traverseAndReplace(item))
            }
        }
    }

    traverseAndReplace(clonedObj)
    return clonedObj
}
